import React, { useContext } from "react";
import './Footer.css';
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

const translations = {
  mr: {
    contactHeading: "संपर्क",
    contactAddresses: [
      {
        lines: [
          "|| प्रधान सेवा केंद्र, श्री क्षेत्र दिंडोरी ||",
          "श्री स्वामी समर्थ सेवा व आध्यात्मिक विकास केंद्र",
          "दिंडोरी, तालुका: दिंडोरी, जिल्हा: नाशिक",
          "पिन कोड नं.-४२२२१२",
          "फोन नंबर: (०२५५७) २२१७१० | इमेल: contact@dindoripranit.org"
        ]
      },
      {
        lines: [
          "|| गुरुपीठ, श्री क्षेत्र त्र्यंबकेश्वर ||",
          "सद्गुरु प.पू. मोरेदादा हॉस्पिटल आणि मेडिकल ट्रस्ट",
          "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ",
          "त्र्यंबकेश्वर, तालुका: नाशिक, जिल्हा: नाशिक",
          "पिन कोड नं.-४२२२१२",
          "फोन नंबर: ९९२२४२०००४ | ईमेल : ayuhospital@gurupith.in & moredadahospital@gurupith.in",
        ]
      }
      
    ],
    getInvolvedHeading: "सहभाग घ्या",
    getInvolvedText: "अन्न वितरण, आरोग्य सेवा आणि शिक्षण कार्यक्रमांचे समर्थन करा. तुमचा योगदान मंदिर, रुग्णालये आणि ग्रामीण विकास उपक्रम चालविण्यात मदत करतो.",
    donateBtn: "देणगी करा",
    learnMoreBtn: "अधिक माहिती",
    rightsReserved: "— सर्व हक्क सुरक्षित आहेत.",
    footerCopyright: "माहिती व तंत्रज्ञान विभाग श्री स्वामी समर्थ सेवा मार्ग दिंडोरी प्रणित",
    privacyPolicy: "गोपनीयता धोरण"
  },
  en: {
    contactHeading: "Contact",
    contactAddresses: [
      {
        lines: [
          "Pradhan Seva Kendra, Shri Kshetra Dindori",
          "Shri Swami Samarth Seva & Spiritual Development Center",
          "Dindori, Taluka: Dindori, District: Nashik",
          "Pin Code No.-422202",
          "Phone: (02557) 221710 | Email: contact@dindoripranit.org"
        ]
      },
      {
        lines: [
          "Gurupeeth, Shri Kshetra Trimbakeshwar",
          "Sadhguru P.P. Moredada Hospital and Medical Trust",
          "Akhil BharatiyaShri Swami Samarth Gurupeeth,",
          "Trimbakeshwar, Taluka: Nashik Division, District : Nashik",
          "Pin Code No.-422212",
          "Phone Number: 9922420004 | Email : ayuhospital@gurupith.in & moredadahospital@gurupith.in",
        ]
      },
    ],
    getInvolvedHeading: "Get involved",
    getInvolvedText: "Support free food distribution, health services, and education programs. Your contribution helps run temples, hospitals, and rural development initiatives.",
    donateBtn: "Donate Now",
    learnMoreBtn: "Learn More",
    rightsReserved: "— All rights reserved.",
    footerCopyright: "Information & Technology Department Shri Swami Samarth Seva Marg Dindori Pranit",
    privacyPolicy: "Privacy Policy"
  }
};

const Footer = () => {
  const { lang } = useContext(LanguageContext);
  const currentYear = new Date().getFullYear();
  const t = (key) => translations[lang][key] || translations["en"][key];

  // Function to convert English numerals to Marathi/Devanagari numerals
  const convertToMarathiNumerals = (num) => {
    const marathiDigits = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return num.toString().split('').map(digit => marathiDigits[parseInt(digit)]).join('');
  };

  // Get the year in appropriate format based on language
  const displayYear = lang === 'mr' ? convertToMarathiNumerals(currentYear) : currentYear;

  return (
    <section id="footer-section" className="wrap" aria-label="Footer Section">
      <footer id="contact" className="footer" aria-label="Footer">
        <div className="footer-grid">
          {/* Contact Section */}
          <div className="footer-section footer-address-section">
            <h3>{t("contactHeading")}</h3>
            <div className="footer-address-container">
              {Array.isArray(t("contactAddresses")) &&
                t("contactAddresses").map((address, idx) => (
                  <div key={idx} className="footer-address">
                    {address.lines.map((line, lineIdx) => (
                      <p key={lineIdx}>{line}</p>
                    ))}
                  </div>
                ))
              }
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          © {displayYear} {t("footerCopyright")}{" "}
          {t("rightsReserved")}  
          {" | "}
          <Link to="/privacy-policy-dindori" className="privacy-link">
            {t("privacyPolicy")}
          </Link>
        </div>

      </footer>
    </section>
  );
};

export default Footer;